const normalizeEmail = (value) => String(value || '').trim().toLowerCase();

const isCopyableEmail = (value) => normalizeEmail(value).includes('@');

const copyTextToClipboard = async (text) => {
    const value = String(text || '').trim();
    if (!value) {
        return false;
    }

    try {
        if (navigator?.clipboard?.writeText) {
            await navigator.clipboard.writeText(value);
            return true;
        }

        const textarea = document.createElement('textarea');
        textarea.value = value;
        textarea.setAttribute('readonly', '');
        textarea.style.position = 'absolute';
        textarea.style.left = '-9999px';
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
        return true;
    } catch (error) {
        console.error('Unable to copy email.', error);
        return false;
    }
};

const CopyableEmail = ({
    email,
    currentUserEmail = '',
    fallback = 'Not provided',
    className = 'approval-email-line copyable-email',
    addressClassName = 'approval-email-address',
}) => {
    const emailText = String(email || '').trim();
    if (!emailText) {
        return fallback;
    }

    const hideCopyAction = normalizeEmail(emailText) === normalizeEmail(currentUserEmail);
    const shouldShowCopy = isCopyableEmail(emailText) && !hideCopyAction;

    return (
        <span className={className}>
            <span className={addressClassName}>{emailText}</span>
            {shouldShowCopy ? (
                <button
                    type="button"
                    className="approval-email-copy"
                    onClick={() => copyTextToClipboard(emailText)}
                    aria-label={`Copy ${emailText}`}
                >
                    <img
                        src="/icons/content-copy.png"
                        alt=""
                        aria-hidden="true"
                        className="approval-email-icon"
                    />
                </button>
            ) : null}
        </span>
    );
};

export default CopyableEmail;
